// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const nl: ChromeTranslations = {
  'nav.nextPage': 'volgende pagina →',
  'nav.previousPage': '← vorige pagina',
  'nav.continueToLevel': 'door naar level →',
  'nav.backToMenu': 'terug naar menu →',
  'howto.page': 'pagina {n} van {total}',
  'options.title': 'Opties',
  'ui.language': 'Taal',
};
